import { render, staticRenderFns } from "./ItemsRecord.vue?vue&type=template&id=327fb53e&"
import script from "./ItemsRecord.vue?vue&type=script&lang=js&"
export * from "./ItemsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ItemsRecord.vue"
export default component.exports